import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/* Layout */
import Layout from '../views/layout/Layout';

/**
 未启用

 //当设置 noredirect 的时候该路由在面包屑导航中不可被点击
 redirect: 'noredirect'
 name: 'router-name'
 //设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题
 meta: {
  noCache: true //如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
  breadcrumb: false // 如果设置为false，则不会在breadcrumb面包屑中显示
}
 **/
export const constantRouterMap = [{
        path: '/login',
        component: () =>
            import('@/views/login/index')
    },
    {
        path: '/404',
        component: () =>
            import('@/views/404')
    },
    {
        path: '/refresh',
        component: Layout,
        hidden: true,
        children: [
          {
            path: '/refresh',
            component: () => import('@/components/djui/DjRefresh')
          }
        ]
      },
    {
        path: '/',
        component: Layout,
        redirect: 'index',
        children: [{
                path: 'index',
                name: 'dashboard',
                component: () =>
                    import('@/views/dashboard/index'),
                meta: {
                    title: '首页'
                }
            },
            {
                path: 'manage',
                name: 'Manage',
                component: () =>
                    import('@/views/manage/index'),
                meta: {
                    title: '账号管理'
                }
            },
            {
                path: '403',
                component: () =>
                    import('@/views/403'),
                meta: {}
            }
        ]
    }
];
export const asyncRouterMap = [

    // 职位权限
    {
        path: '/role',
        component: Layout,
        redirect: '/role/list',
        name: 'roleList',
        children: [{
            path: 'list',
            name: 'Role',
            component: () =>
                import('@/views/RoleManage/List/index'),
            meta: {
                title: '职位权限',
                roles: ['roleList']
            }
        }]
    }, // 人员
    {
        path: '/person',
        component: Layout,
        redirect: '/person/list',
        name: 'PersonManage',
        children: [{
            path: 'list',
            name: 'Person',
            component: () =>
                import('@/views/PersonManage/List/index'),
            meta: {
                title: '员工管理',
                roles: ['User_list']
            }
        }]
    },
    //操作日志
    {
        path: '/log',
        component: Layout,
        redirect: '/log/list',
        name: 'LogManage',
        children: [{
            path: 'list',
            name: 'ActivityLog', //ActivityLog
            component: () =>
                import('@/views/ActivityLog/List/index'),
            meta: {
                title: '操作日志',
                roles: ['Sys_ActivityLog'] //Sys_ActivityLog
            }
        }]
    },
    //会员解绑
    {
        path: '/unbundling',
        component: Layout,
        redirect: '/unbundling/list',
        name: 'Unbundling',
        children: [{
            path: '/unbundling/list',
            name: 'Unbundling',
            component: () =>
                import('@/views/PersonManage/Unbundling/index'),
            meta: {
                title: '会员解绑',
                roles: ['Unbundling']
            }
        }]
    },


    // 门店管理
    {
        path: '/store',
        component: Layout,
        redirect: '/store/list',
        name: 'StoreManage',
        children: [{
            path: '/store/list',
            name: 'Store',
            component: () =>
                import('@/views/StoreManage/List/index'),
            meta: {
                title: '门店列表',
                noCache: false,
                roles: ['Store_list']
            }
        }]
    }, // 门店编辑
    {
        path: '/storeEdit',
        component: Layout,
        redirect: '/store/edit',
        name: '',
        children: [{
            path: '/store/edit',
            name: 'StoreEdit',
            component: () =>
                import('@/views/StoreManage/StoreEdit/Edit'),
            meta: {
                title: '门店编辑',
                roles: ['Store_edit']
            }
        }]
    },


    // //添加门店城市
    // {
    //     path: '/storeCity',
    //     component: Layout,
    //     redirect: '/storeCity/index',
    //     name: '',
    //     children: [{
    //         path: '/storeCity/index',
    //         name: 'StoreCity',
    //         component: () =>
    //             import('@/views/StoreManage/StoreCity/index'),
    //         meta: {
    //             title: '添加门店城市',
    //             roles: ['store_City']
    //         }
    //     }]
    // },


    //门店导购名单
    // {
    //   path: '/shoppingList',
    //   component: Layout,
    //   redirect: '/shoppingList/index',
    //   name: '',
    //   children: [{
    //     path: '/shoppingList/index',
    //     name: 'ShoppingList',
    //     component: () =>
    //       import('@/views/StoreManage/ShoppingList/index'),
    //     meta: {
    //       title: '导购名单',
    //       roles: ['shopping_list']
    //     }
    //   }]
    // },
    //会员列表
    {
        path: '/memberList',
        component: Layout,
        redirect: '/memberList/list',
        name: 'MemberUser',
        children: [{
            path: '/memberList/list',
            name: 'MemberList',
            component: () =>
                import('@/views/MemberUser/List/index'),
            meta: {
                title: '会员列表',
                noCache: false,
                roles: ['member_list']
            }
        }]
    },
    {
        path: '/taglist',
        component: Layout,
        redirect: '/taglist/index',
        name: '',
        children: [{
            path: '/taglist/index',
            name: 'TagList',
            component: () =>
                import('@/views/MemberUser/TagList/index'),
            meta: {
                title: '添加标签',
                roles: ['Tag_List']
            }
        }]
    },
    {
        path: '/member',
        component: Layout,
        redirect: '/member/add',
        name: '',
        children: [{
            path: '/member/add',
            name: 'MemberAdd',
            component: () =>
                import('@/views/MemberUser/MemberCheck/add'),
            meta: {
                title: '新增会员',
                roles: ['member_check']
            }
        }]
    },
    {
        path: '/membercheck',
        component: Layout,
        redirect: '/membercheck/index',
        name: '',
        children: [{
            path: '/membercheck/index',
            name: 'MemberCheck',
            component: () =>
                import('@/views/MemberUser/MemberCheck/index'),
            meta: {
                title: '查看会员',
                roles: ['member_check']
            }
        }]
    },
    //积分记录
    {
        path: '/memberRecord',
        component: Layout,
        redirect: '/memberRecord/index',
        name: '',
        children: [{
            path: '/memberRecord/index',
            name: 'MemberRecord',
            component: () =>
                import('@/views/MemberUser/MemberRecord/index'),
            meta: {
                title: '积分记录',
                roles: ['member_record']
            }
        }]
    },
    //积分记录
    {
        path: '/localMemberRecord',
        component: Layout,
        redirect: '/localMemberRecord/index',
        name: '',
        children: [{
            path: '/localMemberRecord/index',
            name: 'LocalMemberRecord',
            component: () =>
                import('@/views/MemberUser/MemberRecord/localIndex'),
            meta: {
                title: '积分记录',
                roles: ['member_record']
            }
        }]
    },
    //会员币
    {
        path: '/moneyio',
        component: Layout,
        redirect: '/moneyio/index',
        name: '',
        children: [{
            path: '/moneyio/index',
            name: 'MoneyIO',
            component: () =>
                import('@/views/MemberUser/MoneyIO/index'),
            meta: {
                title: '会员币记录',
                roles: ['moneyio']
            }
        }]
    },
    //专题列表
    {
        path: '/preferredlist',
        component: Layout,
        redirect: '/preferredlist/list',
        name: 'Goods',
        children: [{
            path: '/preferredlist/list',
            name: 'PreferredList',
            component: () =>
                import('@/views/Goods/PreferredList/index'),
            meta: {
                title: '专题列表',
                roles: ['preferred_list']
            }
        }]
    },
    //专题商品列表
    {
        path: '/preferredlist',
        component: Layout,
        redirect: '/preferredlist/setSpecial',
        name: 'setSpecial',
        children: [{
            path: '/preferredlist/setSpecial',
            name: 'setSpecial',
            component: () =>
                import('@/views/Goods/PreferredList/setSpecial/index'),
            meta: {
                title: '专题商品列表',
                roles: ['setSpecial']
            }
        }]
    },
    //定制列表
    {
        path: '/customList',
        component: Layout,
        redirect: '/customList/list',
        name: 'customList',
        children: [{
            path: '/customList/list',
            name: 'customList',
            component: () =>
                import('@/views/Goods/customList/index'),
            meta: {
                title: '定制列表',
                roles: ['customList']
            }
        }]
    },
    //商品列表
    {
        path: '/goodslist',
        component: Layout,
        redirect: '/goodslist/index',
        children: [{
            path: '/goodslist/index',
            name: 'GoodsList',
            component: () =>
                import('@/views/Goods/GoodsList/index'),
            meta: {
                title: '商品列表',
                roles: ['goods_list'],
                noCache: false,
            }
        }]
    },
    //后端商品分类
    {
        path: '/bgGoostype',
        component: Layout,
        redirect: '/bgGoostype/index',
        name: '',
        children: [{
            path: '/bgGoostype/index',
            name: 'BGGoodsType',
            component: () =>
                import('@/views/Goods/BGGoodsType/index'),
            meta: {
                title: '后端商品分类',
                roles: ['bg_goodsType']
            }
        }]
    },
    //款式
    {
        path: '/pattern',
        component: Layout,
        redirect: '/pattern/index',
        name: '',
        children: [{
            path: '/pattern/index',
            name: 'PatternIndex',
            component: () =>
                import('@/views/Goods/pattern/index'),
            meta: {
                title: '款式',
                roles: ['pattern']
            }
        }
        ]
    },
    //类别
    {
        path: '/watchband',
        component: Layout,
        redirect: '/watchband/index',
        name: '',
        children: [{
            path: '/watchband/index',
            name: 'WatchbandIndex',
            component: () =>
                import('@/views/Goods/Watchband/index'),
            meta: {
                title: '类别',
                roles: ['watchband']
            }
        }
        ]
    },
    //编辑商品
    {
        path: '/editgoods',
        component: Layout,
        redirect: '/editgoods/index',
        name: '',
        children: [{
            path: '/editgoods/index',
            name: 'EditGoods',
            component: () =>
                import('@/views/Goods/EditGoods/index'),
            meta: {
                title: '操作商品',
                roles: ['edit_goods']
            }
        }]
    },
    //商品规格
    {
        path: '/goodsnorms',
        component: Layout,
        redirect: '/goodsnorms/index',
        name: '',
        children: [{
            path: '/goodsnorms/index',
            name: 'GoodsNorms',
            component: () =>
                import('@/views/Goods/GoodsNorms/index'),
            meta: {
                title: '商品规格',
                roles: ['goods_norms']
            }
        }]
    },
    //商品设置兑换
    {
        path: '/EditGoodsExchange',
        component: Layout,
        redirect: '/editgoodsexchange/index',
        name: '',
        children: [{
            path: '/editgoodsexchange/index',
            name: 'EditGoodsExchange',
            component: () =>
                import('@/views/Goods/EditGoodsExchange/index'),
            meta: {
                title: '商品兑换配置',
                roles: ['goods_exchange']
            }
        }]
    },
    //商品分类
    {
        path: '/goodstype',
        component: Layout,
        redirect: '/goodstype/index',
        name: '',
        children: [{
            path: '/goodstype/index',
            name: 'GoodsType',
            component: () =>
                import('@/views/Goods/GoodsType/index'),
            meta: {
                title: '品牌',
                roles: ['goods_type']
            }
        }]
    },
    //商品标签
    {
        path: '/producttag',
        component: Layout,
        redirect: '/producttag/index',
        name: '',
        children: [{
            path: '/producttag/index',
            name: 'ProductTag',
            component: () =>
                import('@/views/Goods/ProductTag/index'),
            meta: {
                title: '商品标签',
                roles: ['product_tag']
            }
        }]
    },
    //商品种类
    {
        path: '/goodsKind',
        component: Layout,
        redirect: '/goodsKind/index',
        name: '',
        children: [{
            path: '/goodsKind/index',
            name: 'GoodsKind',
            component: () =>
                import('@/views/Goods/GoodsKind/index'),
            meta: {
                title: '品类',
                roles: ['GoodsKind']
            }
        }]
    },
    //线上订单
    {
        path: '/ordermanage',
        component: Layout,
        redirect: '/ordermanage/list',
        name: 'OrderManage',
        children: [{
            path: '/ordermanage/list',
            name: 'OnlineOrder',
            component: () =>
                import('@/views/OrderManage/OnlineOrder/index'),
            meta: {
                title: '销售订单',
                roles: ['order_manage'],
                noCache: false,
            }
        },{
            path: '/repairorder/index',
            name: 'RepairOrderIndex',
            component: () =>
                import('@/views/OrderManage/RepairOrderIndex/index'),
            meta: {
                title: '维修订单',
                roles: ['repair_order_list'],
                noCache: false,
            }
        }]
    },
    {
        path: '/ordermanage/addsale',
        component: Layout,
        redirect: '/ordermanage/addsale',
        name: 'OrderManage',
        children: [{
            path: '/ordermanage/addsale',
            name: 'AddSaleOrder',
            component: () =>
                import('@/views/OrderManage/addSale/index'),
            meta: {
                title: '创建销售单',
                roles: ['order_manage'],
                noCache: false,
            }
        },{
            path: '/ordermanage/saleedit',
            name: 'OrderSaleEdit',
            component: () =>
                import('@/views/OrderManage/SaleEdit/index'),
            meta: {
                title: '销售单',
                roles: ['order_manage'],
                noCache: false,
            }
        }]
    },
    {
        path: '/ordermanage/addrepair',
        component: Layout,
        redirect: '/ordermanage/addrepair',
        name: 'OrderManage',
        children: [{
            path: '/ordermanage/addrepair',
            name: 'AddOrderRepair',
            component: () =>
                import('@/views/OrderManage/addRepair/index'),
            meta: {
                title: '创建维修单',
                roles: ['repair_order_detail'],
                noCache: false,
            }
        },{
            path: '/ordermanage/repairedit',
            name: 'OrderRepairEdit',
            component: () =>
                import('@/views/OrderManage/RepairEdit/index'),
            meta: {
                title: '编辑维修单',
                roles: ['repair_order_detail'],
                noCache: false,
            }
        }]
    },
    //发票列表
    {
        path: '/billsList',
        component: Layout,
        redirect: '/billsList/billsList',
        name: 'billsList',
        children: [{
            path: '/billsList/billsList',
            name: 'billsList',
            component: () =>
                import('@/views/OrderManage/billsList/billsList'),
            meta: {
                title: '线上订单',
                roles: ['billsList']
            }
        }]
    },
    //订单详情
    {
        path: '/waitpay',
        component: Layout,
        redirect: '/waitpay/list',
        name: '',
        children: [{
            path: '/waitpay/list',
            name: 'WaitPay',
            component: () =>
                import('@/views/OrderManage/WaitPay/index'),
            meta: {
                title: '订单详情',
                roles: ['wait_pay']
            }
        }]
    },
    //订单跟踪
    {
        path: '/tracking',
        component: Layout,
        redirect: '/tracking/list',
        name: '',
        children: [{
            path: '/tracking/list',
            name: 'Tracking',
            component: () =>
                import('@/views/OrderManage/Tracking/index'),
            meta: {
                title: '订单跟踪',
                roles: ['tracking']
            }
        }]
    },
    //退款列表
    {
        path: '/drawback',
        component: Layout,
        redirect: '/drawback/list',
        name: '',
        children: [{
            path: '/drawback/list',
            name: 'Drawback',
            component: () =>
                import('@/views/OrderManage/Drawback/index'),
            meta: {
                title: '退款列表',
                roles: ['Drawback'],
                noCache: false,
            }
        }]
    },
    {
        path: '/drawback',
        component: Layout,
        redirect: '/drawback/add',
        name: '',
        children: [{
            path: '/drawback/add',
            name: 'DrawbackAdd',
            component: () =>
                import('@/views/OrderManage/Drawback/add'),
            meta: {
                title: '申请退货退款',
                roles: ['Drawback'],
                noCache: false,
            }
        }]
    },
    //退款列表详情
    {
        path: '/drawback_detail',
        component: Layout,
        redirect: '/drawback_detail/list',
        name: '',
        children: [{
            path: '/drawback_detail/list',
            name: 'Drawback_detail',
            component: () =>
                import('@/views/OrderManage/Drawback/Drawback_detail/index'),
            meta: {
                title: '退款列表详情',
                roles: ['Drawback_detail']
            }
        }]
    },
    //退货列表
    {
        path: '/returnlist',
        component: Layout,
        redirect: '/returnlist/list',
        name: '',
        children: [{
            path: '/returnlist/list',
            name: 'ReturnList',
            component: () =>
                import('@/views/OrderManage/ReturnList/index'),
            meta: {
                title: '退货单列表',
                noCache: false,
                roles: ['return_list']
            }
        }]
    },
    //退货-待处理
    {
        path: '/returnpending',
        component: Layout,
        redirect: '/returnpending/list',
        name: '',
        children: [{
            path: '/returnpending/list',
            name: 'ReturnPending',
            component: () =>
                import('@/views/OrderManage/returnpending/index'),
            meta: {
                title: '退货-待处理',
                roles: ['return_pending']
            }
        }]
    },
    //卡券列表
    {
        path: '/cardticket',
        component: Layout,
        redirect: '/cardticket/list',
        name: '',
        children: [{
            path: '/cardticket/list',
            name: 'CardTicket',
            component: () =>
                import('@/views/CardTicket/CardList/index'),
            meta: {
                title: '卡券列表',
                roles: ['card_ticket'],
                noCache: false,
            }
        }]
    },
    //查看优惠券
    {
        path: '/checkcard',
        component: Layout,
        redirect: '/checkcard/list',
        name: '',
        children: [{
            path: '/checkcard/list',
            name: 'CheckCard',
            component: () =>
                import('@/views/CardTicket/CheckCard/index'),
            meta: {
                title: '查看优惠券',
                roles: ['check_card']
            }
        }]
    },
    //创建优惠券
    {
        path: '/createcard',
        component: Layout,
        redirect: '/createcard/list',
        name: '',
        children: [{
            path: '/createcard/list',
            name: 'CreateCard',
            component: () =>
                import('@/views/CardTicket/CreateCard/index'),
            meta: {
                title: '创建优惠券',
                roles: ['create_card']
            }
        }]
    },
    { //编辑优惠券
        path: '/createcard1',
        component: Layout,
        redirect: '/createcard/list',
        name: '',
        children: [{
            path: '/createcard/list',
            name: 'CreateCard1',
            component: () =>
                import('@/views/CardTicket/CreateCard/index'),
            meta: {
                title: '编辑优惠券',
                roles: ['create_card1']
            }
        }]
    },
    // //礼品列表
    // {
    //     path: '/giftlist',
    //     component: Layout,
    //     redirect: '/giftlist/list',
    //     name: '',
    //     children: [{
    //         path: '/giftlist/list',
    //         name: 'GiftList',
    //         component: () =>
    //             import('@/views/Gift/GiftList/index'),
    //         meta: {
    //             title: '礼品列表',
    //             noCache: false,
    //             roles: ['gift_list']
    //         }
    //     }]
    // },
    // //编辑礼品
    // {
    //     path: '/editgift',
    //     component: Layout,
    //     redirect: '/editgift/index',
    //     name: '',
    //     children: [{
    //         path: '/editgift/index',
    //         name: 'EditGift',
    //         component: () =>
    //             import('@/views/Gift/EditGift/index'),
    //         meta: {
    //             title: '编辑礼品',
    //             roles: ['edit_gift']
    //         }
    //     }]
    // },
    // //添加礼品
    // {
    //     path: '/editgift1',
    //     component: Layout,
    //     redirect: '/editgift/index',
    //     name: '',
    //     children: [{
    //         path: '/editgift/index',
    //         name: 'EditGift1',
    //         component: () =>
    //             import('@/views/Gift/EditGift/index'),
    //         meta: {
    //             title: '添加礼品',
    //             roles: ['edit_gift1']
    //         }
    //     }]
    // },
    //商品设置兑换
    {
        path: '/exchangegift',
        component: Layout,
        redirect: '/exchangegift/index',
        name: '',
        children: [{
            path: '/exchangegift/index',
            name: 'ExchangeGift',
            component: () =>
                import('@/views/Gift/ExchangeGift/index'),
            meta: {
                title: '礼品兑换配置',
                roles: ['gift_exchange']
            }
        }]
    },
    //轮播列表
    {
        path: '/carousel',
        component: Layout,
        redirect: '/carousel/index',
        name: '',
        children: [{
            path: '/carousel/index',
            name: 'Carousel',
            component: () =>
                import('@/views/Carousel/index'),
            meta: {
                title: '轮播组列表',
                roles: ['Carousel'],
                noCache: true,
            }
        }]
    },
    //轮播组列表
    {
        path: '/singleCarousel',
        component: Layout,
        redirect: '/singleCarousel/index',
        name: '',
        children: [{
            path: '/singleCarousel/index',
            name: 'singleCarousel',
            component: () =>
                import('@/views/Carousel/singleCarousel/index'),
            meta: {
                title: '轮播列表',
                roles: ['singleCarousel']
            }
        }]
    },
    //轮播添加/编辑
    {
        path: '/addCarousel',
        component: Layout,
        redirect: '/addCarousel/index',
        name: '',
        children: [{
            path: '/addCarousel/index',
            name: 'AddCarousel',
            component: () =>
                import('@/views/Carousel/addCarousel/index'),
            meta: {
                title: '操作轮播',
                roles: ['AddCarousel']
            }
        }]
    },
    //签到设置
    {
        path: '/getSetting',
        component: Layout,
        redirect: '/getSetting/index',
        name: '',
        children: [{
            path: '/getSetting/index',
            name: 'GetSetting',
            component: () =>
                import('@/views/GetSetting/index'),
            meta: {
                title: '签到设置',
                roles: ['GetSetting']
            }
        }]
    },
    //抽奖设置
    {
        path: '/lottery',
        component: Layout,
        redirect: '/lottery/index',
        name: '',
        children: [{
            path: '/lottery/index',
            name: 'Lottery',
            component: () =>
                import('@/views/Lottery/index'),
            meta: {
                title: '抽奖设置',
                roles: ['Lottery']
            }
        }]
    },
    //中奖记录
    {
        path: '/lottery/winRecord',
        component: Layout,
        redirect: '/lottery/winRecord',
        name: '',
        children: [{
            path: '/lottery/winRecord',
            name: 'winRecord',
            component: () =>
                import('@/views/Lottery/winRecord'),
            meta: {
                title: '中奖记录',
                roles: ['winRecord'],
                noCache: false
            }
        }]
    },
    //商城设置
    {
        path: '/Lottery/mallSetting',
        component: Layout,
        redirect: '/Lottery/mallSetting',
        name: '',
        children: [{
            path: '/Lottery/mallSetting',
            name: 'mallSetting',
            component: () =>
                import('@/views/Lottery/mallSetting'),
            meta: {
                title: '商城设置',
                roles: ['mallSetting']
            }
        }]
    },
    //预售活动
    {
        path: '/yuList/yuList',
        component: Layout,
        redirect: '/yuList/yuList',
        name: '',
        children: [{
            path: '/yuList/yuList',
            name: 'yuList',
            component: () =>
                import('@/views/YuActive/List/index'),
            meta: {
                title: '预售活动',
                roles: ['yuList']
            }
        }]
    },
    //添加预售活动
    {
        path: '/yuActive/yuActive',
        component: Layout,
        redirect: '/yuActive/yuActive',
        name: '',
        children: [{
            path: '/yuActive/yuActive',
            name: 'yuActive',
            component: () =>
                import('@/views/YuActive/yuActive'),
            meta: {
                title: '预售活动',
                roles: ['yuActive']
            }
        }]
    },
    //预售活动详情
    {
        path: '/yuOrder/yuOrder',
        component: Layout,
        redirect: '/yuOrder/yuOrder',
        name: '',
        children: [{
            path: '/yuOrder/yuOrder',
            name: 'yuOrder',
            component: () =>
                import('@/views/YuActive/yuOrder/index'),
            meta: {
                title: '预售详情',
                roles: ['yuOrder']
            }
        }]
    },
    //预售数据列表
    {
        path: '/yuDetail/yuDetail',
        component: Layout,
        redirect: '/yuDetail/yuDetail',
        name: '',
        children: [{
            path: '/yuDetail/yuDetail',
            name: 'yuDetail',
            component: () =>
                import('@/views/YuActive/yuDetail/index'),
            meta: {
                title: '数据列表',
                roles: ['yuDetail']
            }
        }]
    },
    //拼团活动
    {
        path: '/pinList/pinList',
        component: Layout,
        redirect: '/pinList/pinList',
        name: '',
        children: [{
            path: '/pinList/pinList',
            name: 'pinList',
            component: () =>
                import('@/views/PinActive/List/index'),
            meta: {
                title: '拼团活动',
                roles: ['pinList']
            }
        }]
    },
    //添加拼团活动
    {
        path: '/pinActive/pinActive',
        component: Layout,
        redirect: '/pinActive/pinActive',
        name: '',
        children: [{
            path: '/pinActive/pinActive',
            name: 'pinActive',
            component: () =>
                import('@/views/PinActive/pinActive'),
            meta: {
                title: '拼团活动',
                roles: ['pinActive']
            }
        }]
    },
    //砍价活动
    {
        path: '/kanList/kanList',
        component: Layout,
        redirect: '/kanList/kanList',
        name: '',
        children: [{
            path: '/kanList/kanList',
            name: 'kanList',
            component: () =>
                import('@/views/KanActive/List/index'),
            meta: {
                title: '砍价活动',
                roles: ['kanList']
            }
        }]
    },
    //添加砍价活动
    {
        path: '/kanActive/kanActive',
        component: Layout,
        redirect: '/kanActive/kanActive',
        name: '',
        children: [{
            path: '/kanActive/kanActive',
            name: 'kanActive',
            component: () =>
                import('@/views/KanActive/kanActive'),
            meta: {
                title: '砍价活动',
                roles: ['kanActive']
            }
        }]
    },
    //秒杀活动
    {
        path: '/miaoList/miaoList',
        component: Layout,
        redirect: '/miaoList/miaoList',
        name: '',
        children: [{
            path: '/miaoList/miaoList',
            name: 'miaoList',
            component: () =>
                import('@/views/miaoActive/List/index'),
            meta: {
                title: '秒杀活动',
                roles: ['miaoList']
            }
        }]
    },
    //添加秒杀活动
    {
        path: '/miaoActive/miaoActive',
        component: Layout,
        redirect: '/miaoActive/miaoActive',
        name: '',
        children: [{
            path: '/miaoActive/miaoActive',
            name: 'miaoActive',
            component: () =>
                import('@/views/MiaoActive/miaoActive'),
            meta: {
                title: '秒杀活动',
                roles: ['miaoActive']
            }
        }]
    },
    //推荐设置
    {
        path: '/Lottery/recomMend',
        component: Layout,
        redirect: '/Lottery/recomMend',
        name: '',
        children: [{
            path: '/Lottery/recomMend',
            name: 'recomMend',
            component: () =>
                import('@/views/Lottery/recomMend'),
            meta: {
                title: '推荐设置',
                roles: ['recomMend']
            }
        }]
    },
    //直播设置
    {
        path: '/LiveSetting/index',
        component: Layout,
        redirect: '/LiveSetting/index',
        name: '',
        children: [{
            path: '/LiveSetting/index',
            name: 'liveSetting',
            component: () =>
                import('@/views/LiveSetting/index'),
            meta: {
                title: '直播列表',
                roles: ['liveSetting']
            }
        }]
    },
    //直播添加/修改
    {
        path: '/editLive/index',
        component: Layout,
        redirect: '/editLive/index',
        name: '',
        children: [{
            path: '/editLive/index',
            name: 'editLive',
            component: () =>
                import('@/views/LiveSetting/editLive/index'),
            meta: {
                title: '直播设置',
                roles: ['editLive']
            }
        }]
    },
    //公司介绍
    {
        path: '/editLive/index',
        component: Layout,
        redirect: '/editLive/index',
        name: '',
        children: [{
            path: '/editLive/index',
            name: 'editLive',
            component: () =>
                import('@/views/LiveSetting/editLive/index'),
            meta: {
                title: '直播设置',
                roles: ['editLive']
            }
        }]
    },
    // //信息功能 短信记录
    // {
    //     path: '/Message/SMSLog',
    //     component: Layout,
    //     redirect: '/Message/SMSLog',
    //     name: '',
    //     children: [{
    //         path: '/Message/SMSLog',
    //         name: 'SMSLog',
    //         component: () =>
    //             import('@/views/Message/SMSLog/index'),
    //         meta: {
    //             title: '短信记录',
    //             roles: ['SMSLog']
    //         }
    //     }]
    // },
    //消息模板记录
    // {
    //     path: '/Message/WXLog',
    //     component: Layout,
    //     redirect: '/Message/WXLog',
    //     name: '',
    //     children: [{
    //         path: '/Message/WXLog',
    //         name: 'WXLog',
    //         component: () =>
    //             import('@/views/Message/WXLog/index'),
    //         meta: {
    //             title: '消息模板记录',
    //             roles: ['WXLog']
    //         }
    //     }]
    // },
    // //手动发送信息
    // {
    //     path: '/Message/SendSMS',
    //     component: Layout,
    //     redirect: '/Message/SendSMS',
    //     name: '',
    //     children: [{
    //         path: '/Message/SendSMS',
    //         name: 'SendSMS',
    //         component: () =>
    //             import('@/views/Message/SendSMS/index'),
    //         meta: {
    //             title: '发送短信信息',
    //             roles: ['SendSMS']
    //         }
    //     }]
    // },
    //手动发送信息
    {
        path: '/Activity/Index',
        component: Layout,
        redirect: '/Activity/Index',
        name: '',
        children: [{
                path: '/Activity/Index',
                name: 'ActivityIndex',
                component: () =>
                    import('@/views/Activity/index'),
                meta: {
                    title: '活动报名',
                    noCache: false,
                    roles: ['Activity']
                }
            },
            {
                path: '/activity/edit',
                name: 'Activity_Edit',
                component: () =>
                    import('@/views/Activity/edit'),
                meta: {
                    title: '活动报名创建'
                }
            },
            {
                path: '/activity/joinUserIndex',
                name: 'Activity_JoinUserIndex',
                component: () =>
                    import('@/views/Activity/joinUserIndex'),
                meta: {
                    title: '活动报名会员'
                }
            }
        ]
    },
    {
        path: '/companydesc/index',
        component: Layout,
        redirect: '/companydesc/edit',
        name: '',
        children: [{
                path: '/companydesc/index',
                name: 'CompanyDescEdit',
                component: () =>
                    import('@/views/CompanyDesc/edit.vue'),
                meta: {
                    title: '公司介绍',
                    noCache: true,
                    roles: ['mallSetting_edit']
                }
            },
            {
                path: '/costpointgetconfig/edit',
                name: 'CostPointGetConfigEdit',
                component: () =>
                    import('@/views/CostPointGetConfig/edit.vue'),
                meta: {
                    title: '消费得积分配置',
                    noCache: true,
                    roles: ['mallSetting_edit']
                }
            },
            {
                path: '/saletips/edit',
                name: 'SaleTipsEdit',
                component: () =>
                    import('@/views/SaleTips/edit.vue'),
                meta: {
                    title: '销售单提示',
                    noCache: true,
                    roles: ['mallSetting_edit']
                }
            },
            {
                path: '/memberleveldesc/edit',
                name: 'MemberLevelDescEdit',
                component: () =>
                    import('@/views/MemberLevelDesc/edit.vue'),
                meta: {
                    title: '会员权益',
                    noCache: true,
                    roles: ['mallSetting_edit']
                }
            }
        ]
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true
    }
];

export default new Router({
    mode: 'history', // 后端支持可开
    scrollBehavior: () => ({
        y: 0
    }),
    // 本来想动态做router.addRoutes()的
    routes: asyncRouterMap.concat(constantRouterMap)
});



// WEBPACK FOOTER //
// ./src/router/index.js